import "./Slider.scss";

import { IModelApp } from "@itwin/core-frontend";
import {
  Button,
  ButtonType,
  Dialog,
  DialogAlignment,
  Input,
  Slider,
} from "@itwin/core-react";
import { ModalDialogManager, ModelessDialogManager } from "@itwin/appui-react";

import { CustomToolbarItem } from "@itwin/components-react";

import React, { useEffect, useState } from "react";
import { SliderEditor, useToolbarPopupContext } from "@itwin/components-react";
import { cView } from "./View";

export enum SliderLocation {
  Left = 1,
  Right = 2,
  Bottom = 3,
}

export function SliderPanel({
  onSlider,
  onPopup,
  onClose,
}: {
  onSlider?: any;
  onPopup?: any;
  onClose?: any;
}) {
  const [sliderValues, setSliderValues] = useState(0);
  const [isActive, setActive] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line no-console
    if (onPopup) {
      const value = onPopup();
      if (value === undefined) {
        //        closePanel();  // prevents message from appearing in status bar???
        setActive(false);
      } else {
        setActive(true);
        setSliderValues(value);
        setSliderPosition(value);
      }
      console.log("mounting my panel: " + value);
    }

    return () => {
      // eslint-disable-next-line no-console
      console.log("unmounting my panel");
      if (onClose) onClose();
    };
  }, []);

  function setSliderPosition(value: number) {
    if (value !== undefined) {
      const html = document.getElementById("slider") as HTMLInputElement;
      if (html) {
        html.value = value.toString();
      }
    }
    console.log("useEffect: " + value);
  }

  const { closePanel } = useToolbarPopupContext();

  const handleApply = React.useCallback(() => {
    closePanel();
  }, [closePanel]);

  //  const handleChange = React.useCallback((values) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    if (onSlider) onSlider(value);
    setSliderValues(value);
  };

  return (
    <div style={{ width: "200px", height: "38px", padding: "9px" }}>
      <input
        id="slider"
        type="range"
        min={0}
        max={100}
        disabled={!isActive}
        defaultValue={sliderValues}
        onChange={handleChange}
        style={{ width: "100%" }}
      ></input>
    </div>
  );
}

// <Slider min={0} max={100} showTooltip={false} values={[sliderValues]} step={1} onUpdate={handleChange} />

export class cSlider {
  private static _width = 50;
  private static _height = 50;
  private static _x: number;
  private static _y: number;
  private static _image?: string;
  private static _divWidth: number;
  private static _divHeight: number;
  private static _divHTML?: HTMLElement;
  private static _callback?: any;

  public static startSliderTool(
    id: string,
    location: SliderLocation,
    callback: any
  ) {
//    const vp = IModelApp.viewManager.selectedView!;
    const vp = cView.getCurrentView();

    this._divWidth = vp.viewRect.right;
    this._divHeight = vp.viewRect.bottom;
    var x: number, y: number;

    this._callback = callback;
    switch (location) {
      case SliderLocation.Right: {
        x = cSlider._divWidth - 100;
        y = cSlider._divHeight / 2 - 50;
        break;
      }
      case SliderLocation.Left: {
        x = 60;
        y = cSlider._divHeight / 2 - 50;
        break;
      }
      case SliderLocation.Bottom: {
        x = cSlider._divWidth / 2 - 100;
        y = cSlider._divHeight - 60;
        break;
      }
      default: {
        x = 60;
        y = 60;
        break;
      }
    }

    this.openSlider(id, x, y);
  }

  public static stopSliderTool(id: string) {
    cSlider.closeDialog(id);
  }

  // public static openSlider = (x: number, y:number) => {
  //   ModelessDialogManager.openDialog(
  //     <Dialog opened={true} modal={false} hideHeader={true}
  //             x={x} y={y}
  //             width={40} height={150} minWidth={40}>
  //     <div className="slider-vertical">
  //     {/*<Slider min={1} max={100} values={[1]} step={1} showTooltip={false}></Slider> */}
  //     <input type="range" min={0} max={100} defaultValue={0} onChange={cSlider.onChange}></input>
  //     </div>
  //     </Dialog>,"S");
  // };

  public static openSlider = (id: string, x: number, y: number) => {
    ModelessDialogManager.openDialog(cSlider.sliderDialog(x, y), id);
  };

  public static sliderDialog(x: number, y: number): React.ReactNode {
    return (
      <Dialog
        backgroundStyle={{ opacity: "0.9" }}
        opened={true}
        modal={false}
        hideHeader={true}
        x={x}
        y={y}
        inset={true}
        width={40}
        height={150}
        minWidth={40}
      >
        <div className="slider-vertical">
          <input
            type="range"
            min={0}
            max={100}
            defaultValue={0}
            onChange={cSlider.onChange}
          ></input>
        </div>
      </Dialog>
    );
  }

  //      {/*<Slider min={1} max={100} values={[1]} step={1} showTooltip={false}></Slider> */}

  public static closeDialog = (id: string) => {
    ModelessDialogManager.closeDialog(id);
  };

  public static resetDialog = () => {};

  private static onChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const num = Number(event.target.value);
    if (cSlider._callback) cSlider._callback(num);
  };

  public static popupSliderButton(
    id: string,
    priority: number,
    iconSpec: string,
    label: string,
    onSlide: any,
    onPopup?: any,
    onClose?: any
  ): CustomToolbarItem {
    const sliderButton: CustomToolbarItem = {
      isCustom: true,
      id: id,
      itemPriority: priority,
      isPressed: true,
      icon: iconSpec,
      isActive: true,
      label: label,
      // panelContentNode: (
      //   <div style={{ width: "200px", height: "38px", padding: "6px", boxSizing: "border-box"}}>
      //   <Slider min={0} max={100} values={[50]} step={1} />
      //   </div>),
      panelContentNode: (
        <SliderPanel onSlider={onSlide} onPopup={onPopup} onClose={onClose} />
      ),
    };

    return sliderButton;
  }
}
